<div
  class="performance-limits u-border-radius border-color u-padding-16 tile-color-background"
  [ngClass]="{
    'u-opacity-1': (dataPointNumber === 0 && anglePositionNumber === 1) || anglePositionNumber <= dataPointNumber,
    'u-opacity-point-3': isApplyOverlay,
  }"
>
  <div
    [ngClass]="{
      'u-overlay-off': (dataPointNumber === 0 && anglePositionNumber === 1) || anglePositionNumber <= dataPointNumber,
      'u-overlay': isApplyOverlay,
    }"
  ></div>
  <span
    *ngIf="angleName"
    class="primary-text-color line-height-12 u-font-weight-700 u-font-size-xsmall u-margin-bottom-8 u-text-uppercase u-display-block"
    >{{ angleName }}</span
  >
  <span class="u-display-block u-margin-bottom-8 u-font-size-16 u-font-weight-700 line-height-18"
    >Set Performance Limits for: {{ config.metricName }}</span
  >
  <span class="u-display-block performance-limits__sub-text u-font-size-14 u-font-weight-400 line-height-16">{{
    config.description
  }}</span>
  <div>
    <mat-tab-group>
      <mat-tab *ngFor="let tab of tabs; trackBy: trackByTabKey" [formGroup]="tab.form" [label]="tab.name">
        <div class="u-margin-top-20">
          <div
            class="performance-limits__gender-inputs border-color u-padding-16 u-margin-bottom-20"
            [ngClass]="{ 'u-opacity-point-5': tab.isConverting }"
          >
            <span class="u-display-block u-font-size-16 u-font-weight-400 line-height-24">Male</span>
            <div class="u-margin-top-10">
              <div class="o-flex o-flex--justify-space-between">
                <mat-form-field appearance="outline" floatLabel="always" class="width-32-percent">
                  <mat-label>Upper</mat-label>
                  <input
                    *ngIf="!tab.isCustom && isTextInput()"
                    readonly
                    disabled
                    matInput
                    placeholder="Enter Value"
                    [value]="tab.form.value?.male_upper"
                  />
                  <input
                    *ngIf="!tab.isCustom && !isTextInput()"
                    readonly
                    disabled
                    type="number"
                    matInput
                    placeholder="Enter Value"
                    [value]="tab.form.value?.male_upper"
                  />
                  <input
                    *ngIf="tab.isCustom && !isTextInput()"
                    type="number"
                    matInput
                    placeholder="Enter Value"
                    formControlName="male_upper"
                    (input)="onCustomTabValueChanged(tab)"
                  />
                  <input
                    *ngIf="tab.isCustom && isTextInput()"
                    matInput
                    placeholder="Enter Value"
                    formControlName="male_upper"
                    (input)="onCustomTabValueChanged(tab)"
                  />
                  <mat-error *ngIf="tab.form.get('male_upper')?.hasError('min')">should be > 0</mat-error>
                  <mat-error *ngIf="tab.form.get('male_upper')?.hasError('invalid')">mm:ss or mm:ss.s</mat-error>
                </mat-form-field>
                <mat-form-field appearance="outline" floatLabel="always" class="width-32-percent">
                  <mat-label>Lower</mat-label>
                  <input
                    *ngIf="!tab.isCustom && isTextInput()"
                    readonly
                    disabled
                    matInput
                    placeholder="Enter Value"
                    [value]="tab.form.value?.male_lower"
                  />
                  <input
                    *ngIf="!tab.isCustom && !isTextInput()"
                    readonly
                    disabled
                    type="number"
                    matInput
                    placeholder="Enter Value"
                    [value]="tab.form.value?.male_lower"
                  />
                  <input
                    *ngIf="tab.isCustom && !isTextInput()"
                    type="number"
                    matInput
                    placeholder="Enter Value"
                    formControlName="male_lower"
                    (input)="onCustomTabValueChanged(tab)"
                  />
                  <input
                    *ngIf="tab.isCustom && isTextInput()"
                    matInput
                    placeholder="Enter Value"
                    formControlName="male_lower"
                    (input)="onCustomTabValueChanged(tab)"
                  />
                  <mat-error *ngIf="tab.form.get('male_lower')?.hasError('min')">should be > 0</mat-error>
                  <mat-error *ngIf="tab.form.get('male_lower')?.hasError('invalid')">mm:ss or mm:ss.s</mat-error>
                </mat-form-field>
                <mat-form-field appearance="outline" floatLabel="always" class="width-32-percent">
                  <mat-label>Std/Dev</mat-label>
                  <input
                    *ngIf="!tab.isCustom && isTextInput()"
                    readonly
                    disabled
                    matInput
                    placeholder="Enter Value"
                    [value]="tab.form.value?.male_stdDev"
                  />
                  <input
                    *ngIf="!tab.isCustom && !isTextInput()"
                    readonly
                    disabled
                    type="number"
                    matInput
                    placeholder="Enter Value"
                    [value]="tab.form.value?.male_stdDev"
                  />
                  <input
                    *ngIf="tab.isCustom && !isTextInput()"
                    type="number"
                    matInput
                    placeholder="Enter Value"
                    formControlName="male_stdDev"
                  />
                  <input
                    *ngIf="tab.isCustom && isTextInput()"
                    matInput
                    placeholder="Enter Value"
                    formControlName="male_stdDev"
                  />
                  <mat-error *ngIf="tab.form.get('male_stdDev')?.hasError('min')">should be > 0</mat-error>
                </mat-form-field>
              </div>
            </div>
          </div>
          <div
            class="performance-limits__gender-inputs border-color u-padding-16"
            [ngClass]="{ 'u-opacity-point-5': tab.isConverting }"
          >
            <span class="u-display-block u-font-size-16 u-font-weight-400 line-height-24">Female</span>
            <div class="u-margin-top-10">
              <div class="o-flex o-flex--justify-space-between">
                <mat-form-field appearance="outline" floatLabel="always" class="width-32-percent">
                  <mat-label>Upper</mat-label>
                  <input
                    *ngIf="!tab.isCustom && isTextInput()"
                    readonly
                    disabled
                    matInput
                    placeholder="Enter Value"
                    [value]="tab.form.value?.female_upper"
                  />
                  <input
                    *ngIf="!tab.isCustom && !isTextInput()"
                    readonly
                    disabled
                    type="number"
                    matInput
                    placeholder="Enter Value"
                    [value]="tab.form.value?.female_upper"
                  />
                  <input
                    *ngIf="tab.isCustom && !isTextInput()"
                    type="number"
                    matInput
                    placeholder="Enter Value"
                    formControlName="female_upper"
                    (input)="onCustomTabValueChanged(tab)"
                  />
                  <input
                    *ngIf="tab.isCustom && isTextInput()"
                    matInput
                    placeholder="Enter Value"
                    formControlName="female_upper"
                    (input)="onCustomTabValueChanged(tab)"
                  />
                  <mat-error *ngIf="tab.form.get('female_upper')?.hasError('min')">should be > 0</mat-error>
                  <mat-error *ngIf="tab.form.get('female_upper')?.hasError('invalid')">mm:ss or mm:ss.s</mat-error>
                </mat-form-field>
                <mat-form-field appearance="outline" floatLabel="always" class="width-32-percent">
                  <mat-label>Lower</mat-label>
                  <input
                    *ngIf="!tab.isCustom && isTextInput()"
                    readonly
                    disabled
                    matInput
                    placeholder="Enter Value"
                    [value]="tab.form.value?.female_lower"
                  />
                  <input
                    *ngIf="!tab.isCustom && !isTextInput()"
                    readonly
                    disabled
                    type="number"
                    matInput
                    placeholder="Enter Value"
                    [value]="tab.form.value?.female_lower"
                  />
                  <input
                    *ngIf="tab.isCustom && !isTextInput()"
                    type="number"
                    matInput
                    placeholder="Enter Value"
                    formControlName="female_lower"
                    (input)="onCustomTabValueChanged(tab)"
                  />
                  <input
                    *ngIf="tab.isCustom && isTextInput()"
                    matInput
                    placeholder="Enter Value"
                    formControlName="female_lower"
                    (input)="onCustomTabValueChanged(tab)"
                  />
                  <mat-error *ngIf="tab.form.get('female_lower')?.hasError('min')">should be > 0</mat-error>
                  <mat-error *ngIf="tab.form.get('female_lower')?.hasError('invalid')">mm:ss or mm:ss.s</mat-error>
                </mat-form-field>
                <mat-form-field appearance="outline" floatLabel="always" class="width-32-percent">
                  <mat-label>Std/Dev</mat-label>
                  <input
                    *ngIf="!tab.isCustom && isTextInput()"
                    readonly
                    disabled
                    matInput
                    placeholder="Enter Value"
                    [value]="tab.form.value?.female_stdDev"
                  />
                  <input
                    *ngIf="!tab.isCustom && !isTextInput()"
                    readonly
                    disabled
                    type="number"
                    matInput
                    placeholder="Enter Value"
                    [value]="tab.form.value?.female_stdDev"
                  />
                  <input
                    *ngIf="tab.isCustom && !isTextInput()"
                    type="number"
                    matInput
                    placeholder="Enter Value"
                    formControlName="female_stdDev"
                  />
                  <input
                    *ngIf="tab.isCustom && isTextInput()"
                    matInput
                    placeholder="Enter Value"
                    formControlName="female_stdDev"
                  />
                  <mat-error *ngIf="tab.form.get('female_stdDev')?.hasError('min')">should be > 0</mat-error>
                </mat-form-field>
              </div>
            </div>
          </div>
        </div>
      </mat-tab>
    </mat-tab-group>
  </div>
</div>
